import styled from 'styled-components';

export const WrapperLogo = styled.div`

.logo {
  width: 170px;
  padding-top: 20px;
  padding-bottom: 20px;
  cursor: pointer;
  pointer-events: all;
}

@media (max-width: 426px){

}

@media (max-width: 375px){

}

@media (max-width: 321px){

}
`;

export default WrapperLogo;